import { render, staticRenderFns } from "./FastHistoryItems.vue?vue&type=template&id=20110fab&scoped=true&"
import script from "./FastHistoryItems.vue?vue&type=script&lang=ts&"
export * from "./FastHistoryItems.vue?vue&type=script&lang=ts&"
import style0 from "./FastHistoryItems.vue?vue&type=style&index=0&id=20110fab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20110fab",
  null
  
)

export default component.exports